import type {
  ChargeItemDefinitionGetAllParams,
  ChargeItemDefinitionGetAllResponse,
  ChargeItemDefinitionGetResponse,
  CreateChargeItemDefinition,
  CreateChargeItemDefinitionResponse,
  UpdateChargeItemDefinition,
  UpdateChargeItemDefinitionResponse,
} from '@quromedical/models';
import { trpcClient } from 'trpc';

export class ChargeItemApi {
  public async getChargeItems(
    params: ChargeItemDefinitionGetAllParams,
  ): Promise<ChargeItemDefinitionGetAllResponse> {
    return await trpcClient.chargeItemDefinition.getAll.query(params);
  }

  public async getChargeItem(
    id: string,
  ): Promise<ChargeItemDefinitionGetResponse> {
    return await trpcClient.chargeItemDefinition.getById.query({ id });
  }

  public async createChargeItem(
    body: CreateChargeItemDefinition,
  ): Promise<CreateChargeItemDefinitionResponse> {
    return await trpcClient.chargeItemDefinition.create.mutate({
      ...body,
    });
  }

  public async updateChargeItem(
    body: UpdateChargeItemDefinition,
  ): Promise<UpdateChargeItemDefinitionResponse> {
    return await trpcClient.chargeItemDefinition.update.mutate(body);
  }
}
